export const vpmobile = () => {
    const maxMobileWidth = getComputedStyle(document.documentElement)
        .getPropertyValue('--kr-mobile-width')
        .trim();
    return !!(window.matchMedia(`(max-width: ${maxMobileWidth})`).matches);
};
